import gql from 'graphql-tag';

export const all = gql`{
    companies {
        id
        name
        isUnderwriter
        rebateRate
        address
        country {
            id
            name
            isoCode
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/company.js